import { GET_COO_STATISTICS_URL } from '../../services/api/coo-statistics/CooStatisticsApi';
import legacy from '../../services/api/axios';

export const get_total_active_wifi_subscribers = async (selectedYear, selectedCountry) => {
  const initialDateClicked = {
    from: `${selectedYear}-01-01`,
    to: `${selectedYear}-12-31`,
  };

  const initialExpirationState = {
    action: 'get_active_expired_wifi_subscribers',
    type: 'Active',
    ...initialDateClicked,
    country: `${selectedCountry}`,
  };

  // Create FormData instead of URLSearchParams
  const formData = new FormData();
  // Add each key-value pair to the FormData object
  Object.entries(initialExpirationState).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    const headers = {
      // No need to specify Content-Type for FormData as it's set automatically
      // 'Content-Type': 'application/x-www-form-urlencoded',
    };

    // Send FormData directly without toString()
    const res = await legacy.post(`/index.php`, formData);
    if (res.data) {
      console.log(res.data);
      return res.data;
    }
  } catch (error) {
    console.error(error);
  }
  // console.log(isLoading);
};
